import { Button } from "@/components/ui/button";
import { useCategories } from "@/hooks/useCategories";
import { useBrands } from "@/hooks/useBrands";

interface ProductFiltersProps {
  selectedCategory: string;
  selectedBrand?: string;
  onCategoryChange: (category: string) => void;
  onBrandChange?: (brand: string) => void;
}

const ProductFilters = ({ 
  selectedCategory, 
  selectedBrand = "",
  onCategoryChange,
  onBrandChange
}: ProductFiltersProps) => {
  const { data: categories = [], isLoading: loadingCategories } = useCategories();
  const { data: brands = [], isLoading: loadingBrands } = useBrands();

  return (
    <div className="space-y-6 mb-8">
      {/* Category Filters */}
      <div>
        <h3 className="text-sm font-semibold mb-3 text-muted-foreground">Categoría</h3>
        {loadingCategories ? (
          <p className="text-muted-foreground text-sm">Cargando categorías...</p>
        ) : (
          <div className="flex flex-wrap gap-3">
            <Button
              variant={selectedCategory === "all" ? "default" : "outline"}
              size="sm"
              onClick={() => onCategoryChange("all")}
              className="transition-all"
            >
              Todas
            </Button>
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={selectedCategory === category.slug ? "default" : "outline"}
                size="sm"
                onClick={() => onCategoryChange(category.slug)}
                className="transition-all"
              >
                {category.name}
              </Button>
            ))}
          </div>
        )}
      </div>

      {/* Brand Filters */}
      {onBrandChange && brands.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold mb-3 text-muted-foreground">Marca</h3>
          {loadingBrands ? (
            <p className="text-muted-foreground text-sm">Cargando marcas...</p>
          ) : (
            <div className="flex flex-wrap gap-3">
              <Button
                variant={!selectedBrand ? "default" : "outline"}
                size="sm"
                onClick={() => onBrandChange("")}
                className="transition-all"
              >
                Todas
              </Button>
              {brands.map((brand) => (
                <Button
                  key={brand.id}
                  variant={selectedBrand === brand.id ? "default" : "outline"}
                  size="sm"
                  onClick={() => onBrandChange(brand.id)}
                  className="transition-all"
                >
                  {brand.name}
                </Button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductFilters;
